import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LIBRARY_LABELS, OTP_REGEX } from '../../constants.helper';
import { OtpService } from './otp.service';

export interface DialogData {
  employeeNo: string;
  cardNo: string;
  email: string;
  mobile: string;
  preferredDevice: string;
  clientID: string;
  apiDomain: string;
  purpose: string;
  firstName: string;
  lastName: string;
  dob: string;
  action: string;
  otpToken: string;
}

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit {
  protected readonly labels = LIBRARY_LABELS.otp;

  formError!: boolean;

  formSuccess!: boolean;

  formMessage!: string;

  otpToken!: string;

  otpForm!: FormGroup;

  preferredDevice!: string;

  isCodeResent!: boolean;

  retryType!: string;

  loading: boolean = false;

  pageLoad: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<OtpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private otpService: OtpService
  ) {}

  ngOnInit(): void {
    this.otpForm = new FormGroup({
      otpNumber: new FormControl(null, [
        Validators.required,
        Validators.pattern(OTP_REGEX),
      ]),
    });
    this.preferredDevice = this.data.preferredDevice;
    if (this.data.purpose === 'activation') this.generateOtp();
    if (this.data.purpose === 'selfserve') this.otpToken = this.data.otpToken;
  }

  updatePreferredDevice(toggleOption: any, retryType: string) {
    if (toggleOption) this.preferredDevice = this.preferredDevice === 'Email' ? 'Mobile' : 'Email';
    this.isCodeResent = true;
    this.retryType = retryType;
  }

  sendOTP() {
    if (this.data.purpose === 'activation') this.generateOtp();
    if (this.data.purpose === 'selfserve') this.validateLandingUser();
  }

  validateLandingUser() {
    this.pageLoad = true;
    this.formSuccess = false;
    this.formError = false;

    const validateUserRequest = {
      employeeId: this.data.employeeNo,
      firstName: this.data.firstName,
      lastName: this.data.lastName,
      dob: this.data.dob,
      action: this.data.action,
      preferredOtpDevice: this.preferredDevice,
    };
    this.otpService
      .validateLandingUser(
        validateUserRequest,
        this.data.apiDomain,
        this.data.clientID
      )
      .subscribe(
        (response) => {
          this.otpToken = response.otpToken;
          if (this.isCodeResent) {
            this.pageLoad = false;
            this.formSuccess = true;
            this.formMessage = this.labels.OTP_RESENT;
            this.retryType = '';
          }
        },
        (error) => {
          this.pageLoad = false;
          this.formError = true;
          this.formMessage = error;
          this.retryType = '';
        }
      );
  }

  generateOtp(): void {
    this.pageLoad = true;
    this.formSuccess = false;
    this.formError = false;
    const otpRequest = {
      employeeId: this.data.employeeNo,
      sdcCardNo: this.data.cardNo,
      preferredOtpDevice: this.preferredDevice,
    };

    this.otpService
      .generateOTP(otpRequest, this.data.apiDomain, this.data.clientID)
      .subscribe(
        (response) => {
          this.otpToken = response.otpToken;
          if (this.isCodeResent) {
            this.pageLoad = false;
            this.formSuccess = true;
            this.formMessage = this.labels.OTP_RESENT;
            this.retryType = '';
          }
        },
        (error) => {
          this.pageLoad = false;
          this.formError = true;
          this.formMessage = error;
          this.retryType = '';
        }
      );
  }

  verifyOtp(el: HTMLElement): void {
    if (this.otpForm.valid) {
      this.loading = true;
      this.formSuccess = false;
      this.formError = false;
      const verifyTokenRequest = {
        otpcode: this.otpForm.get('otpNumber')?.value,
      };
      this.otpService
        .verifyToken(
          verifyTokenRequest,
          this.data.apiDomain,
          this.data.clientID,
          this.otpToken
        )
        .subscribe(
          (response) => {
            this.loading = false;
            this.dialogRef.close(response.verifiedToken);
          },
          (error) => {
            if (error.newToken) {
              this.otpToken = error.newToken;
              error = error.message;
            } else if (error.code && error.code === 'MAXATTEMPTSREACHED') {
              this.sendOTP();
              error = 'Invalid CODE';
            }
            el.scrollTo(0, 0);
            this.formError = true;
            this.loading = false;
            this.formMessage = error;
          }
        );
    }
  }

  closeDialog(): void {
    this.dialogRef.close('cancel');
  }
}
